export function moveUnifeSitename() {
  const unifeSubsitename = document.getElementById("unife-site-name");
  const portalLogoWrapper = document.getElementById("portal-logo-wrapper");

  if (unifeSubsitename && portalLogoWrapper) {
    const copy = unifeSubsitename.cloneNode(true);
    portalLogoWrapper.appendChild(copy);
    unifeSubsitename.remove();
  }
}
